import { transport } from 'config/transport';

export function callApiExportNoiTruReportForAllCongDoan(academicYear, pdf = false) {
    return transport.get(`/trunguong/report/noitru/annually`, { params: { academicYear, pdf }, responseType: 'blob' });
}
